import React from 'react';
import { FiPlus } from 'react-icons/fi';
import PosFavPriceCard from './PosFavPriceCard';

const PosSlotGrid = ({
  slots = [],
  onIncrement,
  onDecrement,
  onKeypad,
  onAddSlot,
  showAddSlot = false,
  emptyLabel = 'No hay favs configurados.',
  scaleWeightKg = null,
  scaleConnected = false,
  actionsDisabled = false,
}) => {
  const hasSlots = Array.isArray(slots) && slots.length > 0;

  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-[repeat(auto-fill,minmax(160px,1fr))]">
      {!hasSlots && !showAddSlot && (
        <div className="col-span-full rounded-2xl border border-dashed border-gray-300 bg-white px-6 py-12 text-center text-sm text-gray-500">
          {emptyLabel}
        </div>
      )}

      {(slots || []).map((slot) => (
        <PosFavPriceCard
          key={slot.key}
          slot={slot}
          onIncrement={onIncrement}
          onDecrement={onDecrement}
          onKeypad={onKeypad}
          scaleWeightKg={scaleWeightKg}
          scaleConnected={scaleConnected}
          interactionDisabled={actionsDisabled}
        />
      ))}

      {showAddSlot && (
        <button
          type="button"
          onClick={() => onAddSlot?.()}
          className="flex min-h-[168px] flex-col items-center justify-center rounded-2xl border border-dashed border-blue-300 bg-gradient-to-br from-blue-50 to-indigo-50 px-3 py-4 text-center text-blue-700 transition hover:border-blue-400 hover:shadow-md"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-blue-700 shadow-sm ring-1 ring-blue-100">
            <FiPlus size={17} />
          </span>
          <div className="mt-2 text-sm font-semibold">Agregar fav</div>
          <div className="mt-1 max-w-[150px] text-xs leading-snug text-blue-700/80">
            Elige una variedad y su precio exacto.
          </div>
        </button>
      )}
    </div>
  );
};

export default PosSlotGrid;
